import PropTypes from 'prop-types';
import React from 'react';
import compose from 'recompose/compose';
import cx from 'classnames';
import Select from 'react-select';
import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import PerfectScrollbar from 'perfect-scrollbar';
import { fetchCompanyPositionsAction } from '../../redux/company-positions';
import Label from '../Forms/Label';
import styles from '../Forms/SelectField/SelectField.css';
import POSITION_TYPES from '../../../constants/position-types';
import '../../styles/react-select.css';
import '!style-loader!css-loader!perfect-scrollbar/css/perfect-scrollbar.css'; // eslint-disable-line

const getOptions = ({ positions, loading, value, positionType, notListed }) => {
    if (loading) {
        return [
            {
                value: 'loading',
                label: 'Loading...',
            },
        ];
    }
    let current = [];
    if (value) {
        current = Array.isArray(value) ? value : [value];
    }
    const options = positions.filter((position) => {
        if (current.indexOf(position.companyPositionID_PK) !== -1) {
            return true;
        }
        return position.display.indexOf(Number(positionType)) !== -1;
    }).map(position => ({
        value: position.companyPositionID_PK,
        label: position.title,
    }));
    if (Number(positionType) === POSITION_TYPES.EMPLOYEE && notListed) {
        options.push({
            label: 'Position Not Listed',
            value: 0,
        });
    }
    return options;
};

const getValue = (value) => {
    // Switching from multi values to -> single value will throw warning
    if (Array.isArray(value) && value.length === 1) {
        return value.length === 1 ? value[0] : null;
    }
    return value;
};

const activateSimpleScroll = () => {
    // eslint-disable-next-line no-undef
    const elements = document.getElementsByClassName('Select-menu');
    const len = elements.length;

    for (let i = 0; i < len; i += 1) {
        new PerfectScrollbar(elements[i], { autoHide: false }); // eslint-disable-line no-new
    }
};


const CompanyPositionsMultiSelect = ({
    positions,
    loading,
    positionType,
    allowMulti,
    className,
    label,
    input,
    meta: { touched, error, warning },
    notListed,
}) => (<div className={cx(styles.selectWrap, className)}>
    <Label name={input.name} text={label} />
    <Select
        value={getValue(input.value)}
        multi={allowMulti || (Array.isArray(input.value) && input.value.length > 1)}
        placeholder={`Choose Position${Number(positionType) === POSITION_TYPES.EMPLOYEE ? '' : ' Applying for'}`}
        onChange={(pos) => {
            let newValue = pos;
            if (newValue) {
                newValue = Array.isArray(pos) ?
                    pos.map(({ value }) => value) : pos.value;
                if (Array.isArray(pos) && pos.length === 1) {
                    newValue = pos[0].value;
                }
            }
            input.onChange(newValue);
        }}
        disabled={!positionType}
        options={getOptions({
            positions,
            loading,
            positionType,
            value: input.value,
            notListed,
        })}
        onOpen={activateSimpleScroll}
        noResultsText={!positionType ? 'Please select candidate or employee first' : 'No results found'}
    />
    {
        touched &&
        ((error && <span className={styles.error}>{error}</span>) ||
        (warning && <span className={styles.warn}>{warning}</span>))
    }
</div>);

CompanyPositionsMultiSelect.propTypes = {
    positions: PropTypes.array,
    loading: PropTypes.bool,
    positionType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    className: PropTypes.string,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    notListed: PropTypes.bool,
    allowMulti: PropTypes.bool,
};

CompanyPositionsMultiSelect.defaultProps = {
    positions: [],
    notListed: true,
};

export default compose(
    connect(({ positions, theme }, { positionType }) => ({
        positions: positions.companyPositionsList,
        loading: positions.loading,
        allowMulti: theme.applyToMultipleJobs && Number(positionType) === POSITION_TYPES.CANDIDATE,
    }), {
        fetchCompanyPositions: fetchCompanyPositionsAction,
    }),
    lifecycle({
        componentDidMount() {
            this.props.fetchCompanyPositions();
        },
    }),
)(CompanyPositionsMultiSelect);



// WEBPACK FOOTER //
// ./src/client/Components/CompanyPositionsMultiSelect/CompanyPositionsMultiSelect.js